import React from 'react';
import { ConfigProvider } from 'antd';
import { customTheme } from '@/app/ThemeProvider/theme';

export const ThemeProvider = ({ children }) => (
  <ConfigProvider theme={customTheme}>{children}</ConfigProvider>
);
